import { getRateString } from '../../helpers/humanization.js';

const getBusinessRkoTerms = item => {
    // Поля: Переводы юрлицам, Снятие наличных, Тариф, Подключение 0руб.
    const conditions = [];
    const priceValue = item.allPrice ? `${item.allPrice} ₽/мес.` : 'Бесплатно';
    conditions.push({ value: priceValue, description: 'Стоимость тарифа', key: 'price' });
    let legal = '';
    if (item.commissionTransferBusiness || item.commissionTransferBusiness === 0) {
        legal = `${item.commissionTransferBusiness} ₽/шт`;
    }
    conditions.push({ value: legal, description: 'Переводы юрлицам', key: 'legal' });
    const comissMoneyTakePercent = item.comissMoneyTakePercent
        ? `от ${getRateString(item.comissMoneyTakePercent)}`
        : 'от 0%';
    conditions.push({ value: comissMoneyTakePercent, description: 'Снятие наличных', key: 'commission' });
    return conditions;
};

export { getBusinessRkoTerms };
//# sourceMappingURL=businessRko.js.map
